// extracted by mini-css-extract-plugin
export default {"backdrop":"Dialog_backdrop__SpLuM","container":"Dialog_container__RkUsd","header":"Dialog_header__PL-4X","body":"Dialog_body__HHrfO"};